import { ProgressImagePathView, TextView, View } from '@gaming/srvg-classes-core';
import { ChunkModel } from "../Model/ChunkModel";
import { ChunkPickerView } from "./ChunkPickerView";
import { CallToActionView } from "./CallToActionView";
import { ChunkIndicatorView } from "./ChunkIndicatorView";

export class ChunkAreaView extends View{
    chunkPickerView: ChunkPickerView;
    callToActionView: CallToActionView;
    //oddsFrame: OddsFrameView;
    selectedChunkModel: ChunkModel;
    offset: number;
    callToActionViewOptions: any;

    constructor(options){
        options = options || {};
        options.name = options.name || 'chunkAreaView';
        super(options);

        this.offset = options.offset || 0;
        this.selectedChunkModel = new ChunkModel();

        var suffix = '';
        var res = this.selector.match( '([0-9]+)$' );
        if( res && res.length ) {
            suffix = '_'+res[0];
        }
        this.name = 'chunkAreaView'+suffix;

        /******************* initialize views ************************/

        // move to handledominitiated, see below
        if( options.chunkPickerView ) {
            this.chunkPickerView = <ChunkPickerView>this.addSubView( new ChunkPickerView( {
                selector: '#chunkPickerView',
                selectedChunkModel: this.selectedChunkModel,
                chunkRangeModel: app.timeline.chunkRangeModel
            } ) );
        }
        else {
            this.chunkPickerView = null;
        }

        options.clock = options.clock || {};

        var callToActionViewOptions = {
            selector: '#calltoactionView'+suffix,
            name:'calltoactionView'+suffix,
            clock: {
                selector: '#clockView'+suffix,
                name: 'clockview'+suffix,
                // has extended layout with spans etc for other layouts needed, for example collapsed view
                layout: options.clock.layout || null,
                hourLayout: options.clock.hourLayout || null
            },
            lockView: new View( { selector: '#lockView'+suffix } ),
            textView: new TextView( { selector: '#calltoactionTextView'+suffix } ),
            seasonView: null,
            seasonNrView: null,
            matchdayView: null,
            matchdayNrView: null,
            selectedChunkModel: this.selectedChunkModel,
            chunkIndicatorView: new ChunkIndicatorView( {
                template: app.templateEngine.template( ChunkIndicatorView )
            } )
        };


        if (options.callToActionViewOptions && options.callToActionViewOptions.progressView){
            //console.log("progressView", options.callToActionViewOptions.progressView);
            callToActionViewOptions['progressView'] = options.callToActionViewOptions.progressView
        }else{
            callToActionViewOptions['progressView'] = new ProgressImagePathView({
                selector: '#progressView'+suffix,
                width: 108,
                height: 44,
                background: srvg.url.image+'cta-color.png',
                pathwidth: 6,
                path: [
                    { x: 52, y: 4 }, { x: 92, y: 4 }, { x: 103, y: 22 }, { x: 92, y: 40 },
                    { x: 4, y: 40 }, { x: 4, y: 4 }, { x: 52, y: 4 }
                ]
            });
        }
        /*            callToActionViewOptions.selector = '#calltoactionView';
        
                    this.callToActionViewOptions = callToActionViewOptions;
        */
        // todo move to handledominstatiated, see below
        this.callToActionView = this.addSubView( new CallToActionView( callToActionViewOptions ) );
    }

    /*      handleDomInstantiated() {
              if( this._options.chunkPickerView ) {
                  this.chunkPickerView = <ChunkPickerView>this.addSubView( new ChunkPickerView( {
                      selector: '#chunkPickerView',
                      selectedChunkModel: this.selectedChunkModel,
                      chunkRangeModel: app.timeline.chunkRangeModel
                  } ) );
                  console.log('picky', this.chunkPickerView);
              }
  
              this.callToActionView = this.addSubView( new CallToActionView( this.callToActionViewOptions ) );
              super.handleDomInstantiated();
          }*/

    // called by chunkpickerviewcontroller for chunkpickerview
    disable() {
        this.chunkPickerView.disable();
    }
}